import { Button, Flex, Text } from "@jsq/ds/core";
import { getFullLegalName } from "../Profiles/utils";
import {
  emptyCell,
  partiesCount,
  partiesNameList,
  personsCountButton,
} from "./styles_vanilla.css";
import { type ControllingPersonEntry } from "./utils";

export type TaxPersonsCountCellProps = {
  persons: ControllingPersonEntry[];
  onClick?: () => void;
};

export const TaxPersonsCountCell = ({ persons, onClick }: TaxPersonsCountCellProps) => {
  if (persons.length === 0) {
    return (
      <Text variant="regular-md" className={emptyCell}>
        --
      </Text>
    );
  }
  const names = persons
    .map((person) => getFullLegalName(person.firstName, person.lastName, person.middleName))
    .join(" · ");
  return (
    <Button
      displayAsLink
      className={personsCountButton}
      onClick={(event) => {
        event.stopPropagation();
        onClick?.();
      }}
    >
      <Flex flexDirection="column" gap={2}>
        <Text variant="strong-md" className={partiesCount}>
          {persons.length}
        </Text>
        <Text variant="secondary-sm" className={partiesNameList}>
          {names}
        </Text>
      </Flex>
    </Button>
  );
};
